module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAOZJREFUKBXNUjEKhDAQHI+zsrAQrG1tbf2AP7DyV/7AL9j7BUGx1kYUGxUVxMIzgYTk4l1x1W2zs7Mz2SWJdl6BH+L57inLEmmawrIs2uq6DlEUwXEcWUomihHH8bksC6f6vj+TJOE1Aw/5GGBdVxiGwWnbtjEMA68ZUFYdxxF1XbM+zfM8SzUpFKPv+8jzHEVRYNs2HMeBIAgUo0Z2VtiLyLIM0zRh33eEYahIlImiom1bahQ5hr8aPc+D67pMK2XlVsWuruswTVOkOP5q5Kob8CdG8uBN06CqKvqTbjbFx3e8E4vcC6HAf3rPKsOGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/piso.png
// module id = 514
// module chunks = 0